import sample_1 from './100_39040.jpg';

export const basicsSlimFitImpressions = {
    sample_1,
};
